module.exports = __webpack_public_path__ + "img/0004.5d3bce49.jpg";